import React from "react";
import {
	Inner,
	TopContainer,
	Divider,
	InfoTitle,
	InfoTitleTemp,
	TopContainerTemp,
} from "./styles";

const LaboratoriesSlide = ({ children, ...restProps }) => (
	<Inner {...restProps}>{children}</Inner>
);

export default LaboratoriesSlide;

LaboratoriesSlide.TopContainer = ({ children, ...restProps }) => {
	return <TopContainer {...restProps}>{children}</TopContainer>;
};

LaboratoriesSlide.Divider = ({ children, ...restProps }) => {
	return <Divider {...restProps}>{children}</Divider>;
};

LaboratoriesSlide.InfoTitle = ({ children, ...restProps }) => {
	return <InfoTitle {...restProps}>{children}</InfoTitle>;
};

LaboratoriesSlide.InfoTitleTemp = ({ children, ...restProps }) => {
	return <InfoTitleTemp {...restProps}>{children}</InfoTitleTemp>;
};
LaboratoriesSlide.TopContainerTemp = ({ children, ...restProps }) => {
	return <TopContainerTemp {...restProps}>{children}</TopContainerTemp>;
};
